import React from 'react'
import lodaingstyles from './Lodaing.module.css'
function Lodaing() {
    return (
        <div className={lodaingstyles.loding}>


            <span className={lodaingstyles.loader}>

            </span>
        </div>
    )
}

export default Lodaing